<template>
    <button
        :disabled="loading"
        class="space-x-2 flex items-center justify-center"
    >
        <icon v-if="loading" type="spinner" class="w-4 h-4" />
        <span><slot></slot></span>
    </button>
</template>

<script>
import Icon from './Icon'

export default {
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
    components: {
        Icon
    }
}
</script>
